import "../../styles/LoadingText.css";

export default function LoadingText({ text = "Loading" }) {
  return (
    <span className="loading-text">
      {text}
      <span className="loading-text__dots" />
    </span>
  );
}
